import React from "react"

import ContentfulVideo from "components/page-components/video"

const Video = ({ element, elRef }) => <ContentfulVideo elRef={elRef} component={element} floating />

export default Video
